document.addEventListener('DOMContentLoaded', function() {

    const open_btns = document.querySelectorAll(".js-sidebar--open")
    const close_btns = document.querySelectorAll(".js-sidebar--close")

    open_btns.forEach(btn => btn.addEventListener("click", function() {
        document.querySelector(".header-sidebar").classList.toggle('open-sidebar');
        document.querySelector(".header-mobile").classList.toggle('open');
        document.querySelector(".header-sidebar").style.display = "block";
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector("#sidebar-overlay").style.display = "block";
        document.querySelector("#icon-close").style.display = "flex";
        document.querySelector("#icon-hamburger").style.display = "none";
        document.querySelector(".header-mobile").style.background = "white";
    }))

    close_btns.forEach(btn => btn.addEventListener("click", function() {
        document.querySelector(".header-sidebar").classList.toggle('open-sidebar');
        document.querySelector(".header-mobile").classList.toggle('open');
        document.querySelector("body").style.overflow = "visible";
        document.querySelector("#icon-close").style.display = "none";
        document.querySelector("#sidebar-overlay").style.display = "none";
        document.querySelector("#icon-hamburger").style.display = "block";
        document.querySelector(".header-mobile").style.background = "transparent";
        setTimeout(function() {
            document.querySelector(".header-sidebar").style.display = "none";
        },400)
    }))

})
